import React from "react";
import cn from "./helpers/cn";

export interface TableContextValue {
  size: "small" | "medium";
  stickyHeader: boolean;
}

export const TableContext = React.createContext<TableContextValue>({
  size: "medium",
  stickyHeader: false,
});

interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  component?: React.ElementType;
  size?: "small" | "medium";
  stickyHeader?: boolean;
  padding?: "normal" | "checkbox" | "none";
  children?: React.ReactNode;
}

const Table = React.forwardRef<HTMLTableElement, TableProps>((props, ref) => {
  const {
    className,
    component: Component = "table",
    size = "medium",
    stickyHeader = false,
    children,
    ...other
  } = props;

  const ctx = React.useMemo<TableContextValue>(() => ({ size, stickyHeader }), [size, stickyHeader]);

  return (
    <TableContext.Provider value={ctx}>
      <Component
        ref={ref}
        className={cn(
          "w-full border-collapse border-spacing-0 text-sm text-left",
          className
        )}
        {...other}
      >
        {children}
      </Component>
    </TableContext.Provider>
  );
});

Table.displayName = "Table";

export default Table;
